var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.imgSrc,"onerror":_vm.defaultImg}})
}
var staticRenderFns = []

export { render, staticRenderFns }